/**
 * Offline Mode detection (STEP 12) — the real, standard browser
 * `navigator.onLine` + `online`/`offline` events. This detects LOCAL
 * network connectivity loss (wifi/ethernet down), not "can this
 * browser reach the NEXAO API specifically" (that's what
 * `core/api/retry.ts`'s network-error handling covers on a per-request
 * basis) — the two are complementary, not the same check.
 */
import { useEffect, useState } from 'react';

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = (): void => setIsOnline(true);
    const handleOffline = (): void => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
